module.exports = __webpack_public_path__ + "f42a1931fcb4164877712c7dc57cc2fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_4.jpg
// module id = 1779
// module chunks = 5